module.exports = __webpack_public_path__ + "img/4.c5f79fdf.jpg";